import { SkillsCheckPanel } from "src/app/_models/SkillsCheck";
import { SkillsCheckState } from "./skills-check-tab.state";

export function getSkillsCheckTabState(
  state: SkillsCheckState,
  action: SkillsCheckPanel[]
): SkillsCheckPanel[] {
  const { result } = state;
  const results: SkillsCheckPanel[] = [...action];
  const hasAddedAttempt: boolean = checkAddedAttempt(state, results);

  if (result === undefined || result.length === 0) {
    return results.map((item, index) => {
      return index === 0 ? { ...item, expanded: true } : item;
    });
  }

  if (hasAddedAttempt === true && result.length !== results.length) {
    const updateAttemptPanel = retainAttemptState(state, results);
    const newPanel = retainPanelState(updateAttemptPanel, results);
    return updateNewPanelState(newPanel, results);
  }

  if (result.length !== results.length) {
    return retainState(state, results);
  }

  if (result[0].name !== results[0].name) {
    return updatePanelState(state, results).map((item, index) => {
      return index === 0 ? { ...item, expanded: true } : item;
    });
  }

  if (result[0].attempt.length !== results[0].attempt.length) {
    return retainAttemptState(state, results);
  }

  if (result.length === results.length) {
    return retainState(state, results);
  }

  return result;
}

export function retainState(
  state: SkillsCheckState,
  action: SkillsCheckPanel[]
): SkillsCheckPanel[] {
  const newItems = action
    .filter(
      (item) => !state.result.some((panelItem) => panelItem.name === item.name)
    )
    .map((item) => ({ ...item, expanded: true }));

  return [...newItems, ...state.result];
}

export function retainPanelState(
  oldPanel: SkillsCheckPanel[],
  action: SkillsCheckPanel[]
): SkillsCheckPanel[] {
  const newItems = action
    .filter(
      (item) => !oldPanel.some((panelItem) => panelItem.name === item.name)
    )
    .map((item) => ({ ...item, expanded: true }));

  return [...newItems, ...oldPanel];
}

export function retainAttemptState(
  state: SkillsCheckState,
  action: SkillsCheckPanel[]
): SkillsCheckPanel[] {
  const tempResult = state.result.map((stateResult) => {
    const tempAction = action.find((x) => x.name === stateResult.name);

    return {
      ...tempAction,
      expanded: tempAction.attempt.length !== stateResult.attempt.length,
    };
  });

  return tempResult;
}

export function updatePanelState(
  state: SkillsCheckState,
  action: SkillsCheckPanel[]
): SkillsCheckPanel[] {
  const tempAction = action.map((newPanel) => {
    const tempResult = state.result.find(
      (stateResult) => stateResult.name === newPanel.name
    );
    return {
      ...newPanel,
      expanded: tempResult.expanded,
    };
  });

  return tempAction;
}

export function updateNewPanelState(
  oldPanel: SkillsCheckPanel[],
  action: SkillsCheckPanel[]
): SkillsCheckPanel[] {
  const tempAction = action.map((newPanel) => {
    const tempResult = oldPanel.find(
      (stateResult) => stateResult.name === newPanel.name
    );
    return {
      ...newPanel,
      expanded: tempResult.expanded,
    };
  });

  return tempAction.map((item, index) => {
    return index === 0 ? { ...item, expanded: true } : item;
  });
}

export function checkAddedAttempt(
  state: SkillsCheckState,
  action: SkillsCheckPanel[]
): boolean {
  var hasNewAttempts: boolean = false;

  state.result.forEach((old) => {
    action.forEach((added) => {
      if (old.name === added.name)
        if (old.attempt.length !== added.attempt.length) hasNewAttempts = true;
    });
  });

  return hasNewAttempts;
}
